export default class AuthService {
  constructor(axios) {
    this.axios = axios
  }

  /**
   * @param {object} ctx
   * @param {string} ctx.username
   * @param {string} ctx.password
   */
  async signIn(ctx) {
    try {
      const { data: { data: token } } = await this.axios.post('auth/signin', ctx)
      this.axios.defaults.headers.common.Authorization = `Bearer ${token}`
      return token
    } catch (error) {
      this.axios.defaults.headers.common.Authorization = null
      if (error.response) {
        // const { data: { message, code } } = error.response
        return error.response.data
        // throw new Error({ message })
      }
      throw error
    }
  }

  async cambiarClave(params) {
    return this.axios.post('auth/resetpass', params)
  }

  async logout() {
    this.axios.defaults.headers.common.Authorization = null
  }
}
